export default {
  historicalData: 'Dados históricos',
  simulated: 'Simulado',
  historical: 'Histórico',
  budget: 'Orçamento',
  attributedSales: 'Atribuído ao marketing',
  weekEnding: 'Semana até {date}'
}
